import { Reveal } from "./Reveal";
import { ContactDetails } from "./ContactDetails";
import { ContactForm } from "./ContactForm";

export const Contact = () => (
  <section id="contacto" data-testid="contact-section" className="relative mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-32">
    <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-5">
        <Reveal>
          <span className="text-sm font-medium uppercase tracking-[0.25em] text-[#00E5FF]">07 — Contacto</span>
          <h2 data-testid="contact-heading" className="mt-5 font-head text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl">
            Pide tu <span className="font-black">presupuesto</span>
          </h2>
          <p data-testid="contact-description" className="mt-6 text-lg leading-relaxed text-zinc-400">
            Cuéntanos sobre tu negocio y te responderemos con una propuesta clara. Sin compromiso.
          </p>
          <ContactDetails />
        </Reveal>
      </div>
      <div className="lg:col-span-7"><Reveal delay={0.1}><ContactForm /></Reveal></div>
    </div>
  </section>
);